import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map } from 'rxjs/internal/operators/map';
import { of } from 'rxjs/internal/observable/of';
import { catchError } from 'rxjs/internal/operators/catchError';
import { mergeMap } from 'rxjs/internal/operators/mergeMap';
import { FarmWeatherLocation } from '../_models/farmWeatherLocation';
import * as FarmWeatherLocationActions from '../_actions/farmWeatherLocation';
import { FarmWeatherLocationService } from '../_services/farmWeatherLocation.service';

@Injectable({
  providedIn: 'root',
})
export class FarmWeatherLocationEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly farmWeatherLocationService: FarmWeatherLocationService
  ) {}

  loadFarmWeatherLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmWeatherLocationActions.loadFarmWeatherLocations),
      mergeMap(() =>
        this.farmWeatherLocationService.getLocations().pipe(
          map((locations: FarmWeatherLocation[]) =>
            FarmWeatherLocationActions.loadFarmWeatherLocationsSuccess({ locations })
          ),
          catchError((error) =>
            of(FarmWeatherLocationActions.loadFarmWeatherLocationsFailure({ error }))
          )
        )
      )
    )
  );

  addFarmWeatherLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmWeatherLocationActions.addFarmWeatherLocation),
      mergeMap(({ location }) =>
        this.farmWeatherLocationService.saveLocation(location).pipe(
          map((location: FarmWeatherLocation) =>
            FarmWeatherLocationActions.addFarmWeatherLocationSuccess({ location })
          ),
          catchError((error) =>
            of(FarmWeatherLocationActions.addFarmWeatherLocationFailure({ error }))
          )
        )
      )
    )
  );

  saveFarmWeatherLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmWeatherLocationActions.updateFarmWeatherLocation),
      mergeMap(({ location }) =>
        this.farmWeatherLocationService.saveLocation(location).pipe(
          map((location: FarmWeatherLocation) =>
            FarmWeatherLocationActions.updateFarmWeatherLocationSuccess({ location })
          ),
          catchError((error) =>
            of(FarmWeatherLocationActions.updateFarmWeatherLocationFailure({ error }))
          )
        )
      )
    )
  );

  deleteFarmWeatherLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmWeatherLocationActions.deleteFarmWeatherLocation),
      mergeMap(({ location }) =>
        this.farmWeatherLocationService.deleteLocation(location).pipe(
          map((location: FarmWeatherLocation) =>
            FarmWeatherLocationActions.deleteFarmWeatherLocationSuccess({ location })
          ),
          catchError((error) =>
            of(FarmWeatherLocationActions.deleteFarmWeatherLocationFailure({ error }))
          )
        )
      )
    )
  );
}
